import React from "react";
import styled from "styled-components";
import { backgrounds } from "../../assets";
import Form from "./Form";

const Container = styled.div`
	max-width: 1280px;
	max-height: 720px;
	display: flex;
`;
const Login = () => {
    return (
        <div className="w-full h-full flex justify-center items-center ">
            <Container className="w-full h-full xl:w-[1280px] xl:h-[700px]">
                <div className="w-1/2 h-full flex justify-center items-center">
                    <div className="w-full h-full  flex justify-center items-center relative bg-1B1464 shadow-2xl">
                        <img className=" w-full h-full absolute top-0 z-1" src={backgrounds.formLoginBackground} alt="login background" />
                        <div className="w-full h-full flex justify-center items-center absolute top-0 z-10  ">
                            <Form />
                        </div>
                    </div>
                </div>
                <div className="w-1/2 h-full flex justify-center items-center">
                    <img src={backgrounds.loginBackground} alt="Man using vr assets" className="object-cover h-full" />
                </div>
            </Container>
        </div>
    );
};

export default Login;
